import { CommonDataService } from 'src/app/core/services/common-data.service';
import { ChangeDetectorRef, Component, Injector, Input, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { UserPreferenceConstants } from 'src/app/core/constants/user-preference-constants.constant';
import { DateTableColumn } from 'src/app/core/models/date-table-column';
import { FacilityOptions } from 'src/app/core/models/options/facility-options';
import { DropdownOptionsService } from 'src/app/core/services/dropdown-options.service';
import { DataTableComponent } from 'src/app/shared/components/data-table/data-table.component';
import { SessionBaseComponent } from 'src/app/shared/components/session.base.component';
import { FacilityPrinterData } from '../../interface/facility-printer-data';
import { ConfirmEventType } from 'primeng/api';
import { fromEvent, throwError } from 'rxjs';
import { debounceTime, distinctUntilChanged, finalize } from 'rxjs/operators';
import { deepCopy, isNullOrEmpty, laaSFormatString, nullIfEmptyArray } from 'src/app/core/utils/common-functions';
import { FacilityPrinterService } from 'src/app/features/setting/service/facility-printer.service';
import { LaasOption } from 'src/app/core/models/laas-option';
import { NotificationSubScriptionService } from 'src/app/core/services/notification-sub-scription.service';
import { MultiSelect } from 'primeng/multiselect';
import { AddressMaintainanceService } from 'src/app/features/setting/service/address-maintainance.service';
import { GetFacilityPrinterRequest } from '../../interface/get-facility-printer-request';
import { PermissionConstants } from 'src/app/core/constants/permission-constants.constant';
import { PageInfo } from 'src/app/core/models/page-info';
import { SortOrder } from 'src/app/core/interface/sort-order';
import { DataTableSavedBean } from 'src/app/shared/components/data-table/bean/data-table-saved-bean';

@Component({
  selector: 'laas-facility-printer',
  templateUrl: './facility-printer.component.html',
  styleUrls: ['./facility-printer.component.scss']
})
export class FacilityPrinterComponent extends SessionBaseComponent implements OnInit {

  @ViewChild(DataTableComponent) table!: DataTableComponent;
  @ViewChild('printerTable') printerTable!: DataTableComponent;
  @ViewChild('consigneeKeySelect') consigneeKeySelect!: MultiSelect
  queryFlag: boolean = true;

  isOpenedPrinterSearchFormTab: boolean = false;
  isOpenedPrinterInfoTab: boolean = false;

  searchFormGroup: FormGroup;
  searchParams:any;

  @Input() facilityCodeOptions: FacilityOptions[] = [];
  printerTypeOptions: LaasOption[] = [];
  deliveryTypeOptions: LaasOption[] = [];
  forwarderCodeOptions: LaasOption[] = [];
  letterHeadOrgIdOptions: LaasOption[] = [];
  consigneeKeyOptions: LaasOption[] = [];
  consigneeKeyOptionsMapping: LaasOption[] = [];
  enableOptions: LaasOption[] = [];

  readonly printerPreferenceKey: string = UserPreferenceConstants.FacilityPrinterData;

  isPrinterTableLoading: boolean = false;

  // DateTableColumn
  columnOfFacilityPrinter: DateTableColumn[] = [
      { field: 'facilityCode', header: 'FacilityPrinter.MainTable.Column.FacilityCode', sort: true },
      { field: 'printerCode', header: 'FacilityPrinter.MainTable.Column.PrinterCode', sort: true },
      { field: 'printerType', header: 'FacilityPrinter.MainTable.Column.PrinterType', sort: true },
      { field: 'deliveryType', header: 'FacilityPrinter.MainTable.Column.DeliveryType', sort: true },
      { field: 'forwarderCode', header: 'FacilityPrinter.MainTable.Column.ForwarderCode', sort: true },
      { field: 'letterHeadOrgId', header: 'FacilityPrinter.MainTable.Column.LetterHeadOrgId', sort: true },
      { field: 'consigneeKey', header: 'FacilityPrinter.MainTable.Column.ConsigneeKey', sort: true },
      { field: 'enable', header: 'FacilityPrinter.MainTable.Column.Enable', sort: true },
      { field: 'createUser', header: 'FacilityPrinter.MainTable.Column.CreateUser', sort: true },
      { field: 'createDt', header: 'FacilityPrinter.MainTable.Column.CreateDt', sort: true },
      { field: 'updateUser', header: 'FacilityPrinter.MainTable.Column.UpdateUser', sort: true },
      { field: 'updateDt', header: 'FacilityPrinter.MainTable.Column.UpdateDt', sort: true },
      { field: '__action', header: '動作', sort: false },
  ];

  printerData: FacilityPrinterData[] = [];

  permissionCode: PermissionConstants = PermissionConstants.ViewAutoPrintSetting;
  readonly editPermissionCode: PermissionConstants = PermissionConstants.EditAutoPrintSetting;

  // Table paging info
  pageInfo: PageInfo = {
    pageSize: 5,
    pageIndex: 0,
    totalRecords: 0,
    totalPages: 0,
  };

  sortOrder: SortOrder = {
    property: "SeqNo",
    direction: -1
  };

  constructor(
    private injector: Injector,
    private formBuilder: FormBuilder,
    private dropdownOptionsService: DropdownOptionsService,
    private facilityPrinterService: FacilityPrinterService,
    private notificationSubScriptionService: NotificationSubScriptionService,
    private addressMaintainanceService: AddressMaintainanceService,
    private changeDetector: ChangeDetectorRef,
    private commonDataService: CommonDataService
  ) {
    super(injector);
    this.searchFormGroup = this.formBuilder.group({
      facilityCode: [this.laasSetting.facility, Validators.required],
      printerTypes: [null, Validators.required],
      deliveryTypes: [null, Validators.required],
      letterHeadOrgIds: [null, Validators.required],
      consigneeKeys: [null, Validators.required],
      forwarderCodes: [null, Validators.required],
    });

    this.searchParams = {
      consigneeKey: null,
      consigneeCompany: null
    };

  }

  async ngOnInit(): Promise<void> {
    await super.ngOnInit();

    this.commonDataService.getCodeConverter(this.laasSetting.language, 'DropdownList', 'PrinterType').subscribe({
      next: result => {
        this.printerTypeOptions = [...result].map((x: any) => {
          return {
            label: `${x.codeKey} - ${x.codeDesc}`,
            value: x.codeKey,
          };
        });
      }
    });

    this.deliveryTypeOptions = [
      { label: 'LOCAL', value: 'LOCAL' },
      { label: 'EXPORT', value: 'EXPORT' },
    ];
    if (this.laasSetting.language == "en-us") {
      this.enableOptions = [
        { label: 'Not Activated', value: 0 },
        { label: 'Activated', value: 1 },
      ];
    } else {
      this.enableOptions = [
        { label: '未啟用', value: 0 },
        { label: '已啟用', value: 1 },
      ];
    }


    this.dropdownOptionsService.getLetterOrgOptions().subscribe({
      next: (result: any[]) => {
        this.letterHeadOrgIdOptions = result.map((x) => ({
            label: x.legalEntityOUName,
            value: x.legalEntityOUCode,
          }));
        this.letterHeadOrgIdOptions.unshift({label: "ALL", value: "ALL"});
      },
    });

    this.addressMaintainanceService.getCustomerOptions().subscribe({
      next: (result) => {
        this.consigneeKeyOptionsMapping = [...result].map((x: any) => {
          return {
            label: `${x.customerCode} - ${x.customerName}`,
            value: x.customerCode,
          };
        });
      },
    });

    this.dropdownOptionsService.getForwarderOptions().subscribe({
        next: (result: any[]) => {
          this.forwarderCodeOptions = result.map((x) => ({
            label: x.optionDesc,
            value: x.optionCode,
          }));
          this.forwarderCodeOptions.unshift({label: "ALL", value: "ALL"});
        }
      });
  }

  resetBtnClick() {
    this.searchFormGroup.reset();
    this.searchFormGroup.controls['facilityCode'].setValue(this.laasSetting.facility);
    this.searchFormGroup.controls['printerTypes'].setValue(null);
    this.searchFormGroup.controls['deliveryTypes'].setValue(null);
    this.searchFormGroup.controls['letterHeadOrgIds'].setValue(null);
    this.searchFormGroup.controls['consigneeKeys'].setValue(null);
    this.searchFormGroup.controls['forwarderCodes'].setValue(null);
  }

  searchBtnClick(): void {
    this.printerTable.loading = true;
    this.printerTable.cancelRowEdit();
    this.printerTable.isInEditMode = false;
    this.printerTable.setCurrentPage(0);
    this.isOpenedPrinterInfoTab = true;
    this.getPrinterTableData();
  }

  getPrinterTableData() {
    let request: any = this.createGetFacilityPrinterRequest();
    request.pageIndex = this.pageInfo.pageIndex,
    request.pageSize = this.pageInfo.pageSize,
    request.sortOrder = this.sortOrder

    this.isPrinterTableLoading = true;

    this.facilityPrinterService.getFacilityPrinter(request)
      .pipe(finalize(() => (this.isPrinterTableLoading = false)))
      .subscribe({
        next: (response: any) => {
          if (isNullOrEmpty(response)) {
            throwError(response);
          }

          this.isOpenedPrinterSearchFormTab = false;
          this.printerData = [];

          //Update table
          if (!isNullOrEmpty(response.content)) {
            this.printerData = deepCopy(response.content) ?? [];
          }
          this.logger.info('printerData=', JSON.stringify(this.printerData));

          this.printerTable.updateTableData(this.printerData);
          if (this.printerTable.selectedRow) {
            this.onRowSelect(this.printerTable.selectedRow);
          }

          // Change page Info
          this.pageInfo.totalRecords = response.totalElements;
          this.printerTable.setPageInfo(this.pageInfo.totalRecords);
        },
        error: (response) => {
          this.printerData = [];
          this.printerTable.updateTableData(this.printerData);
          this.pageInfo.totalRecords = 0;
          this.pageInfo.totalPages = 0;
          this.printerTable.setPageInfo(this.pageInfo.totalRecords);
          this.toastService.error(this.translateService.instant('Common.Toast.GetDataFail') + response.status);
        },
        complete: () => {
          this.logger.info('complete...');
          this.printerTable.loading = false;
        },
      });
  }

  setTableData(response: any) {
    this.printerData = deepCopy(response) ?? [];
  }

  createGetFacilityPrinterRequest(): GetFacilityPrinterRequest {
    let request: GetFacilityPrinterRequest = new GetFacilityPrinterRequest();
    request.facilityCode = this.searchFormGroup.value.facilityCode;
    request.printerTypes = nullIfEmptyArray(this.searchFormGroup.value.printerTypes);
    request.deliveryTypes = nullIfEmptyArray(this.searchFormGroup.value.deliveryTypes);
    request.letterHeadOrgIds = nullIfEmptyArray(this.searchFormGroup.value.letterHeadOrgIds);
    request.consigneeKeys = nullIfEmptyArray(this.searchFormGroup.value.consigneeKeys);
    request.forwarderCodes = nullIfEmptyArray(this.searchFormGroup.value.forwarderCodes);
    return request;
  }

  isInvalidField(): boolean {
    return false;
  }

  getCustomerOptions(event: any) {
    const conText: string = event.filter;
    if (conText == "ALL") {
      this.updateConsigneeKeyOptions([{
        label: "ALL - ALL",
        value: "ALL",
      }]);
    } else if (conText != null && conText.length > 0 && this.queryFlag) {
      this.queryFlag = false;
      this.consigneeKeySelect.value = this.searchParams.consigneeKey;
      this.searchParams.consigneeCompany = this.consigneeKeySelect.valuesAsString;
      if (this.searchParams.consigneeKey != null) {
        this.consigneeKeySelect.value = this.searchParams.consigneeKey;
        this.searchParams.consigneeCompany = this.consigneeKeySelect.valuesAsString;
      }
      this.notificationSubScriptionService.getCustomerOptionsByFilter(conText).subscribe({
        next: (options: any[]) => {
          this.consigneeKeyOptions = options.map<LaasOption>(x => ({
            label: x.customerCode + ' - ' + x.customerName,
            value: x.customerCode,
          }));
          this.consigneeKeySelect._filteredOptions = this.consigneeKeyOptions;
          this.changeDetector.detectChanges();
          this.queryFlag = true;
        }
      });
    }
  }

  private updateConsigneeKeyOptions(options: LaasOption[]) {
    this.consigneeKeyOptions = options;
    this.consigneeKeySelect._filteredOptions = this.consigneeKeyOptions;
    this.changeDetector.detectChanges();
  }

  exportBtnClick(event: any) {
    let request: GetFacilityPrinterRequest = this.createGetFacilityPrinterRequest();

    this.loader.show();
    this.facilityPrinterService.exportFacilityPrinter(request).subscribe({
      next: result => {
        if (result == null || result.size == 0) {
          this.translateService.get('Common.Toast.NoData').subscribe({
            next: i18nResult => {
              this.toastService.info(i18nResult);
            }
          });
          this.loader.hide();
        } else {
          const file = result;

          this.translateService.get("FacilityPrinter_Report").subscribe({
            next: i18nResult => {
              file.name = (new Date().toLocaleDateString() + "_" + i18nResult + ".xlsx");
            }
          });

          const url = URL.createObjectURL(file);
          let a: any = document.createElement('a');
          a.href = url
          a.download = file.name;
          a.click();
          URL.revokeObjectURL(url);
        }
      },
      complete: () => {
        this.loader.hide();
      }
    })
  }

  deleteBtnClick(seqNo: number) {
    this.confirmationService.confirm({
      message: this.translateService.instant('將移除資料庫資料，請問要刪除嗎?'),
      header: this.translateService.instant('系統資訊'),
      icon: 'pi pi-info-circle',
      accept: () => {
        this.loader.show();
        this.facilityPrinterService.deleteFacilityPrinter(seqNo).subscribe({
          next: result => {
            this.toastService.success('資料刪除完成!!');
            this.searchBtnClick();
          },
          error: async response => {
            this.loader.hide();
            this.printerTable.loading = false;
            var instantMsg = await this.translateService.get("Common.Toast.SaveFail").toPromise();
            var msg = `${laaSFormatString(instantMsg, [response.status, response.error.errorMsg])}\n`;
            this.toastService.error(msg);
          },
          complete: () => {
            this.logger.info('complete...');
            this.loader.hide();
            this.printerTable.loading = false;
          },

        });
      },
      reject: (type: any) => {
        switch (type) {
          case ConfirmEventType.REJECT:
            break;
          case ConfirmEventType.CANCEL:
            break;
        }
      }
    });
  }

  createNewRow(rowId: number): any {
    let newRow = {
      seqNo: null,
      facilityCode: this.laasSetting.facility,
      printerCode: null,
      printerType: null,
      deliveryType: null,
      forwarderCode: null,
      letterHeadOrgId: null,
      consigneeKey: null,
      enable: 0,
      createUser: null,
      createDt: null,
      updateUser: null,
      updateDt: null,
      rowId: rowId,
    };
    return newRow;
  }

  dataInputValid(rowData: FacilityPrinterData): boolean {
    if (rowData) {
      if (isNullOrEmpty(rowData.printerCode) || isNullOrEmpty(rowData.printerType) || isNullOrEmpty(rowData.deliveryType)
       || isNullOrEmpty(rowData.letterHeadOrgId) || isNullOrEmpty(rowData.consigneeKey) || isNullOrEmpty(rowData.forwarderCode)) {
        this.toastService.warn(this.translateService.instant('Common.Toast.CheckRequiredFields'));
        return false;
      }
    }
    return true;
  }

  createRow(rowData: any): void {
    this.onRowSelect(rowData);
  }

  onRowSelect(event: any): void {
  }

  saveData(savedDataBean: DataTableSavedBean): void {
    const saveDataRequest = {
      insertList: savedDataBean.newList,
      updateList: savedDataBean.updatedList,
      updateUser: this.userProfile.userName
    };
    this.facilityPrinterService.saveFacilityPrinter(saveDataRequest).subscribe({
      next: () => {
        this.printerTable.saveSuccessEvent();
        this.searchBtnClick();
        this.toastService.success(this.translateService.instant('Common.Toast.SaveSuccess'));
      },
      error: async response => {
        this.printerTable.loading = false;
        var instantMsg = await this.translateService.get("Common.Toast.SaveFail").toPromise();
        var msg = `${laaSFormatString(instantMsg, [response.status, response.error.errorMsg])}\n`;
        this.toastService.error(msg);
      },
      complete: () => {
        this.logger.info('complete...');
        this.printerTable.loading = false;
      },
    });
  }

  restoreData(): void {
    this.ngOnInit();
  }

  tablePageChange(event: any): void {
    this.pageInfo.pageSize = event.rows;
    this.pageInfo.pageIndex = event.first / this.pageInfo.pageSize;
    this.getPrinterTableData();
  }

  tableSort(event: any): void {
    this.sortOrder = { property: event.field, direction: event.order };
    this.printerTable.setCurrentPage(0);
    this.getPrinterTableData();
  }

}
